import { arrangeScopesForProgramSelection } from 'features/Programs/Shared/helperFunctions'
import React, { useEffect, useState } from 'react'
import WorksiteGroupDropdown from './WorksiteGroupDropdown'
import Dropdown from 'core-system/Dropdown'
import styled from 'styled-components'
import Text from 'core-system/Text/Text'
import palette from 'core-system/Themes/palette'
import launchProgramsWordings from 'features/Programs/Shared/wordings.json'
import { Segment } from 'redux/employer/employerTypes'
import DateUtils, { Month } from 'shared/DateUtils'
import { SegmentListType } from '../../Shared/types'
import { useDispatch, useSelector } from 'react-redux'
import { launchProgramsActions } from '../launchProgramActions'
import SegmentService from 'redux/config/services/SegmentService'
import { AppState } from 'redux/config/store'
import { tagsActions } from 'redux/tags/tagsSlice'

const PageItem = styled.div`
  margin-bottom: 2.5rem;
`

const TitleContainer = styled(Text)`
  margin-bottom: 1rem;
  color: ${palette.text.primary};
`

interface WorksitesDateSelectionProps {
  allSegments: Segment[]
  selectedSegments: SegmentListType[]
  selectedDate: Month
  isFromUpdate: boolean
}

const WorksitesDateSelection = ({
  allSegments,
  selectedSegments,
  selectedDate,
  isFromUpdate,
}: WorksitesDateSelectionProps) => {
  const dispatch = useDispatch()
  const allTags = useSelector((state: AppState) => state.tags.allTags)
  const dates = DateUtils.getNextXMonths(6, 1)
  // Making the selected items as state because
  // if we are from update, the user can only update the current segments
  // so we need to keep the selected segments as state
  const [groupSegments, setGroupSegments] = useState(selectedSegments)

  useEffect(() => {
    if (!allTags) {
      dispatch(tagsActions.getTags())
    }
  }, [allTags, dispatch])

  const handleWorksiteSelect = (newItems: SegmentListType[]) => {
    dispatch(launchProgramsActions.changeSelectedSegments(newItems))
    // Clearing out any selected programs
    // if from update, we dont have to do this
    if (!isFromUpdate) {
      dispatch(launchProgramsActions.changeSelectedPrograms([]))
    }
  }

  const handleStartDateChange = (item: Month) => {
    dispatch(launchProgramsActions.changeSelectedDate(item))
    SegmentService.track('baseOptions-toggle-action', {
      actionType: 'starting-date',
    })
  }

  return (
    <>
      <PageItem>
        <TitleContainer variant='h5'>
          {launchProgramsWordings.selectGroupTitle}
        </TitleContainer>
        {/* If we are from update, the user can only update the current segments */}
        <WorksiteGroupDropdown
          items={
            isFromUpdate
              ? groupSegments
              : arrangeScopesForProgramSelection(allSegments, allTags ?? [])
          }
          activeItems={selectedSegments}
          onItemCallback={handleWorksiteSelect}
          width='100%'
          placeholderText='Select worksites, groups, or tags'
        />
      </PageItem>
      {!isFromUpdate && (
        <PageItem>
          <TitleContainer variant='h5'>
            {launchProgramsWordings.selectDateTitle}
          </TitleContainer>
          <Dropdown
            active={selectedDate?.id}
            items={dates}
            itemCallback={handleStartDateChange}
            width='100%'
          />
        </PageItem>
      )}
    </>
  )
}

export default WorksitesDateSelection
